import { Navigate } from "react-router-dom";
import storage from "../../helpers/storage";

const AuthGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}: any) => {
  const authToken = storage.getToken();
  if (authToken) {
    return <Navigate to={"/dashboard"} replace />;
  }
  return children;
};

export default AuthGuard;
